import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const queryTemlateListApi = (params) => {
  return httpService({
    url: contextPath + '/template/page',
    method: 'get',
    params
  })
}

export const createTemplateApi = data => {
  return httpService({
    url: contextPath + '/template/item',
    method: 'post',
    data
  })
}

export const updateTemplateApi = data => {
  return httpService({
    url: contextPath + '/template/item',
    method: 'put',
    data
  })
}

export const toggleTemplateEnabledApi = id => {
  return httpService({
    url: contextPath + `/template/item/${id}`,
    method: 'put',
  })
}